export default __webpack_public_path__ + "static/media/Scry.2347a3f0.png";